import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import BuySectionWithShopList from '../../components/BuySectionWhitShopList/inex';

/**
 * 第三级导航组件
 * @param {Object} props - 组件属性
 * @param {string} props.url - 当前产品URL
 * @param {React.ReactNode} props.productName - 产品名称
 * @param {Array} props.items - 导航项
 * @param {Array} props.activeIndex - 激活的项索引
 * @param {function} props.onItemClick - 项点击事件
 * @param {boolean} props.isSoldOut - 是否已售罄
 * @param {Array} props.getJumpLink - 跳转链接
 * @param {Array} props.goodsShops - 商店列表
 * @param {React.ReactNode} props.buyText - 购买按钮文本
 */
const ThirdLevelNav = ({
  url,
  productName,
  activeItems,
  onItemClick,
  isSoldOut,
  isInquire,
  showInquiryInShopList,
  getJumpLink,
  goodsShops,
  buyText,
  styles,
  locale
}) => {
  const nav1Ref = useRef(null);
  const nav2Ref = useRef(null);
  const nav3Ref = useRef(null);
  
  return (
    <div className={styles.thirdSub}>
      <ul>
        <li className={activeItems[0]} ref={nav1Ref}>
          <NavLink to={`/${url}/overview`} onClick={onItemClick}>
            {productName}
          </NavLink>
          <i className={styles.line} />
        </li>
        <li className={activeItems[1]} ref={nav2Ref}>
          <NavLink to={`/${url}/specifications`} onClick={onItemClick}>
            <FormattedMessage id="specifications" />
          </NavLink>
          <i className={styles.line} />
        </li>
        <BuySectionWithShopList
          isSoldOut={isSoldOut}
          isInquire={isInquire}
          showInquiryInShopList={showInquiryInShopList}
          getJumpLink={getJumpLink}
          goodsShops={goodsShops}
          buyText={buyText}
          locale={locale}
        />
      </ul>
    </div>
  );
};

ThirdLevelNav.propTypes = {
  url: PropTypes.string.isRequired,
  productName: PropTypes.node.isRequired,
  activeItems: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
  isSoldOut: PropTypes.bool,
  isInquire: PropTypes.bool,
  getJumpLink: PropTypes.array,
  goodsShops: PropTypes.array,
  buyText: PropTypes.node,
  styles: PropTypes.object.isRequired
};

export default ThirdLevelNav; 